<rk-modal-wrapper
  (submitted)="onSubmit()"
  (cancelled)="onCancel()"
  (closed)="onCancel()"
  [title]="'MEDIA.MODAL.TRACK.REMOVE_TAG.TITLE' | translate"
  [submitText]="'MEDIA.MODAL.TRACK.REMOVE_TAG.ACTION_BUTTON' | translate"
  [loading]="isLoading$ | async"
  [hideCancelOnLoading]="true"
>
  <form [formGroup]="formTags" novalidate [style.margin-bottom.px]="10">
    <rk-chips-input
      label="{{ 'MEDIA.MODAL.TRACK.REMOVE_TAG.TAGS_TO_REMOVE' | translate }}"
      formControlName="tags"
      [dataFetched]="tagsOfTracks$ | async"
      [withSelectAll]="true"
      [canAddNew]="false"
      [addNewCaseSensitive]="false"
      [placeholder]="'MEDIA.EDIT_TRACK.REMOVE_TAGS_PLACEHOLDER' | translate"
      [modal]="true"
      [isTag]="true"
      [chipMaxLength]="255"
      [style.margin-bottom.px]="-15"
    ></rk-chips-input>
  </form>
</rk-modal-wrapper>
